// ============================================================================
// ENTITY TAX REGISTRATION SERVICE (ADR-0019) — entity-scoped via X-Entity-ID.
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { entityTaxRegistrationEndpoints } from '../endpoints/tax.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse, BackendPagedResult, PaginatedResponse, EmptyResponse, ID,
  EntityTaxRegistrationDto, CreateEntityTaxRegistrationRequest, UpdateEntityTaxRegistrationRequest, EntityTaxRegistrationQueryParams,
} from '../types';

class EntityTaxRegistrationService {
  async getAll(params?: EntityTaxRegistrationQueryParams): Promise<PaginatedResponse<EntityTaxRegistrationDto>> {
    const endpoint = params ? buildEndpointWithQuery(entityTaxRegistrationEndpoints.list(), params) : entityTaxRegistrationEndpoints.list();
    const response = await get<ApiResponse<BackendPagedResult<EntityTaxRegistrationDto>>>(endpoint);
    const paged = response.data.data;
    return {
      success: response.data.success, message: response.data.message,
      data: Array.from(paged.items || []),
      pagination: {
        currentPage: paged.page, pageSize: paged.pageSize, totalPages: paged.totalPages,
        totalItems: paged.totalCount, hasNextPage: paged.hasNext, hasPreviousPage: paged.hasPrevious,
      },
    };
  }
  async create(data: CreateEntityTaxRegistrationRequest): Promise<EntityTaxRegistrationDto> {
    const r = await post<ApiResponse<EntityTaxRegistrationDto>>(entityTaxRegistrationEndpoints.create(), data);
    return r.data.data;
  }
  async update(id: ID, data: UpdateEntityTaxRegistrationRequest): Promise<EntityTaxRegistrationDto> {
    const r = await put<ApiResponse<EntityTaxRegistrationDto>>(entityTaxRegistrationEndpoints.update(id), data);
    return r.data.data;
  }
  async delete(id: ID, rowVersion: number): Promise<EmptyResponse> {
    const url = buildEndpointWithQuery(entityTaxRegistrationEndpoints.delete(id), { rowVersion });
    const r = await del<EmptyResponse>(url);
    return r.data;
  }
}

export const entityTaxRegistrationService = new EntityTaxRegistrationService();
export default entityTaxRegistrationService;
